import { useContext } from "react";
import { ThemeContext } from "./ThemeContext";
import { ApiCompanyThemeDto } from "../models/api/admin/themes";

const useTheme = (): ApiCompanyThemeDto | null => {
    return useContext(ThemeContext);
};

export default useTheme;
